const DashboardButton = ( { url } ) => {
    const arrow_icon = `${EASYCOMMERCE.assets}admin/img/dashboard/arrow.png`;
    return (
        <>
            <a href={url} className="w-16 text-xs text-ec-primary font-inter font-semibold flex items-center gap-2 border-b border-ec-primary pb-2 cursor-pointer">
                View All
                <img src={arrow_icon} alt="" className="w-2 h-4" />
            </a>
        </>
    );
};
export default DashboardButton;